<template>
  <div id="app-container">
    <router-view />
    <AppFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AppFooter from './components/AppFooter.vue';

export default defineComponent({
  name: 'App',
  components: {
    AppFooter
  }
});
</script>

<style>
body {
  background-color: #171713;
  margin: 0;
  padding: 0;
  color: #FFFDF9;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 5%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* These styles will only apply to the home page hero section */
.hero-section {
  margin-bottom: 1rem;
  max-width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
}

.hero-text {
  font-family: Baskervville, "Baskerville Old Face", "Hoefler Text", Garamond, "Times New Roman", serif;
  font-size: 7rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
  line-height: 1.1;
}

.subheading {
  font-family: Baskervville, "Baskerville Old Face", "Hoefler Text", Garamond, "Times New Roman", serif;
  font-size: 3rem;
  margin-bottom: 2rem;
  font-weight: 500;
}

.closer {
  margin-top: -1rem;
}

.message {
  font-family: Baskervville, "Baskerville Old Face", "Hoefler Text", Garamond, "Times New Roman", serif;
  font-size: 1.5rem;
  line-height: 2;
  margin-bottom: 3rem;
  font-weight: 400;
}

.slogan {
  display: block;
  margin-top: 1rem;
  font-size: 2rem;
}

.logo {
  width: 96px;
  height: 96px;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  transform: translateZ(0);
  backface-visibility: hidden;
}

@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .logo {
    width: 96px;
    height: 96px;
  }
}

.social-links {
  margin-top: 2rem;
  margin-bottom: 4rem;
}

.social-links a {
  color: #FFFDF9;
  font-size: 1.5rem;
  margin: 0 1rem;
  text-decoration: none;
  transition: color 0.3s ease;
}

.social-links a:hover {
  color: #FFFDF9;
  opacity: 0.8;
}
</style>
